import {
  DEFAULT_ROUTES,
  PRIME_TRACKING_ROUTES,
  PRO_TRACKING_ROUTES,
} from '@mais-retorno-front/constants/routes';

export const TOOLS_OPTION_MENU = {
  title: 'Ferramentas',
  items: [
    {
      label: 'Gerenciador de carteiras',
      link: DEFAULT_ROUTES.portfolio,
    },
    {
      label: 'Comparador de ativos',
      link: DEFAULT_ROUTES.assetsComparison,
    },
    {
      label: 'Comparador de fundos',
      link: DEFAULT_ROUTES.comparisonFund,
    },
    {
      label: 'Simulador de carteira',
      link: DEFAULT_ROUTES.incomeSimulation,
    },
  ],
};

export const LIST_OPTION_MENU = {
  title: 'Listas',
  items: [
    {
      label: 'Ranking de fundos',
      link: DEFAULT_ROUTES.rankingFund,
    },
    {
      label: 'Lista de Ativos',
      link: DEFAULT_ROUTES.list,
    },
    {
      label: 'Lista de Gestores',
      link: DEFAULT_ROUTES.managerListFund,
    },
    {
      label: 'Lista de Administradores',
      link: DEFAULT_ROUTES.adminListFunds,
    },
  ],
};

export const CONTENT_OPTION_MENU = {
  title: 'Conteúdos',
  items: [
    {
      label: 'Glossário',
      link: DEFAULT_ROUTES.glossary,
    },
    {
      label: 'Podcasts',
      link: DEFAULT_ROUTES.podcast,
    },
    {
      label: 'Vídeos',
      link: DEFAULT_ROUTES.videos,
    },
  ],
};

export const SHEET_OPTIONS = {
  label: 'Planilhas gratuitas',
  icon: '/img/bx-sheets.svg',
  iconAlt: 'Planilhas',
  subItems: [
    {
      label: 'Carteira de radar de Ações',
      link: 'https://lp.maisretorno.com/planilhas-carteira-acoes-01',
    },
    {
      label: 'Relatório de Fundos',
      link: 'https://lp.maisretorno.com/planilhas-relatorio-fundos-01',
    },
  ],
};

export const LEARN_OPTION_MENU = {
  title: 'Conteúdos',
  icon: '',
  items: [
    {
      label: '',
      subItems: CONTENT_OPTION_MENU.items,
    },
    {
      label: 'Treinamentos',
      icon: '/img/bx-mr.svg',
      iconAlt: 'Treinamentos',
      subItems: [
        {
          label: 'Curso Completo sobre Fundos',
          link: 'https://lp.maisretorno.com/como-investir-melhores-fundos-v01',
        },
      ],
    },
    SHEET_OPTIONS,
  ],
};

export const MAIS_RETORNO_MENU = {
  title: 'Sobre a MR',
  iconUrl: '/img/bx-mr.svg',
  iconAlt: 'Logo',
  items: [
    {
      label: 'Quem somos',
      link: DEFAULT_ROUTES.about,
    },
    {
      label: 'Trabalhe Conosco',
      link: DEFAULT_ROUTES.workWithUs,
    },
    {
      label: 'Contato',
      link: DEFAULT_ROUTES.contact,
    },
    {
      label: 'Política de Privacidade',
      link: DEFAULT_ROUTES.privacyPolicy,
    },
    {
      label: 'Termos de uso',
      link: DEFAULT_ROUTES.applicationTerms,
    },
  ],
};

export const PRODUCTS_MENU = {
  title: 'Produtos',
  items: [
    {
      label: 'Retorno Prime',
      subTitle: 'Para Investidor Individual',
      description:
        'Acompanhe o desempenho de suas carteiras, compare ativos, simule investimentos e muito mais.',
      link: PRIME_TRACKING_ROUTES.CTANavbarProduct,
      linkLabel: 'Conhecer o Retorno Prime',
      subItems: [
        {
          label: 'Gerenciador de carteiras',
          link: DEFAULT_ROUTES.portfolio,
        },
        {
          label: 'Simulação de carteira',
          link: DEFAULT_ROUTES.incomeSimulation,
        },
        {
          label: 'Comparador de ativos',
          link: DEFAULT_ROUTES.assetsComparison,
        },
      ],
    },
    {
      label: 'Retorno PRO',
      subTitle: 'Para Profissionais de Investimentos',
      description:
        'Personalize relatórios, gerencie a carteira de clientes, personalize seus relatórios e muito mais.',
      link: PRO_TRACKING_ROUTES.CTANavbarProduct,
      linkLabel: 'Conhecer o Retorno PRO',
      subItems: [
        {
          label: 'Gerenciador de carteiras',
          link: PRO_TRACKING_ROUTES.CTANavbarProduct,
        },
        {
          label: 'Gestão de time',
          link: PRO_TRACKING_ROUTES.CTANavbarProduct,
        },
        {
          label: 'Relatórios personalizados',
          link: PRO_TRACKING_ROUTES.CTANavbarProduct,
        },
      ],
    },
    {
      subTitle: 'Para negócios',
      subItems: [
        {
          label: 'Retorno ADS',
          link: DEFAULT_ROUTES.retornoAdsLp,
        },
        {
          label: 'Comparador White Label',
          link: DEFAULT_ROUTES.retornoPrimeWhiteLabel,
        },
        {
          label: 'API de Dados',
          link: DEFAULT_ROUTES.retornoPrimeAPI,
        },
      ],
    },
  ],
};
